/* eslint-disable react/style-prop-object */
import { faBookMedical, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import {
  Building,
  Calendar2,
  FileText,
  List,
  ListCheck,
  PencilSquare,
  Table,
} from "react-bootstrap-icons";
import Questionnaire from "../../../../../../libs/api/services/Questionnaire";

export default function NewComponentContainer({
  component,
  onPropertyChange,
  ComponentChange,
  onComponentTypeSelected,
}) {
  const [sections, setSections] = useState();

  const Icon = (type) => {
    switch (type) {
      case "Display Text":
        return <FileText className="me-2" />;
      case "Get Input text":
        return <PencilSquare className="me-2" />;
      case "Multiple Selection":
        return <ListCheck className="me-2" />;
      case "Single Selection":
        return <List className="me-2" />;
      case "Date Picker":
        return <Calendar2 className="me-2" />;
      case "Dynamic Component Table":
        return <Table className="me-2" />;
      case "Sub Section":
        return <Calendar2 className="me-2" />;
      case "Facilities":
        return <Building className="me-2" />;
      case "ICD10":
        return <FontAwesomeIcon icon={faBookMedical} className="me-2" />;
      case "PMB":
        return <FontAwesomeIcon icon={faBookMedical} className="me-2" />;
      case "Terms And Conditions":
        return <FontAwesomeIcon icon={faPen} className="me-2" />;
      case "Text Box":
        return <FileText icon={faPen} className="me-2" />;
      default:
        <></>;
    }
  };

  const FilterAndRender = (componentTypes) => {
    var _sections = [];
    for (var componentType of componentTypes) {
      if (componentType.type === "Sub Section") continue; /// These are sub components and are added elsewhere
      // const _idx = idx
      const _type = componentType.type;
      var _section = _sections.find(
        (s) => s.section === componentType.category
      );
      if (_section) {
        //
      } else {
        _sections.push({
          section: componentType.category,
          components: [],
        });
        _section = _sections.find((s) => s.section === componentType.category);
      }
      _section.components.push({
        type: componentType,
        component: <div
          className="p-0"
          key={componentType.id}
        //   onClick={
        //     (e) => handleChange(Component, _type)
        //     //onAction({ action: 'Set Type', type: _type, idx: _idx })
        //   }
        >
          {Icon(_type)}
          {_type}
        </div>
      });
      //_sections.push(<div><b></b></div>)
    }
    setSections(_sections);
  };
  useEffect(() => {
    Questionnaire.ListComponentsTypes().then((r) => {
      FilterAndRender(r);
    });
  }, []);

  const handleChange = (type) => {
    console.log("Changing component type to:", component.componentId, type);
    Questionnaire.SetComponentType(component.componentId, { ...type });
    const updatedComponent = {
      ...component,
      componentType: { type: type.type },
    };
    if (ComponentChange) {
      ComponentChange(updatedComponent);
    }
    if (onComponentTypeSelected) {
      onComponentTypeSelected(updatedComponent);
    }
  };

  return (
    <div style={{ cursor: "pointer" }} className="row m-1 text-center">
      <b>Select the question type</b>
      {sections &&
        sections.map((s) => {
          return (
            <div className="col-6 text-start">
              <div className="text-center bg-primary-container">
                <b>{s.section}</b>
              </div>
              <div className="">
                {s.components.map((c) => (
                  <div onClick={() => handleChange(c.type)}>{c.component}</div>
                ))}
              </div>
            </div>
          );
        })}
    </div>
  );
}
